<template>
  <!-- FORGOT PASSWORD FORM -->
  <div class="container mt--6 pb-5">
    <div class="row justify-content-center">
      <div class="col-lg-5 col-md-7">
        <div class="card bg-secondary border-0 mb-0">
          <div class="card-body px-lg-5 py-lg-4">
            <div class="text-center mb-lg-4 mb-md-4 mb-3">
              <strong>Forgot Password</strong>
            </div>
            <form role="form" @submit.prevent="handleSubmit">
              <base-input
                label="Email"
                class="mb-3"
                type="email"
                placeholder="Enter your email address"
                v-model="form.email"
                spellcheck="false"
                required
              ></base-input>

              <div class="text-center">
                <base-button
                  type="primary"
                  :loading="loading"
                  nativeType="input"
                  block
                  class="my-4"
                  >SUBMIT</base-button
                >Already know your password?&nbsp;
                <router-link to="/login">Log in here.</router-link>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import swal from "sweetalert2";
const apiBaseURL = process.env.VUE_APP_API_URL;

export default {
  name: "forgot-password",
  metaInfo() {
    return {
      title: "Forgot Password - Art Grab",
      meta: [
        {
          vmid: "twitter:card",
          name: "twitter:card",
          content: `summary_large_image`,
        },
        {
          vmid: "twitter:title",
          name: "twitter:title",
          content: `Art Grab : Forgot Password`,
        },
        {
          vmid: "twitter:description",
          name: "twitter:description",
          content: `Forgot your password? No problem, just submit your email address here and we'll reset it for you.`,
        },
        {
          vmid: "twitter:image",
          name: "twitter:image",
          content: "https://i.imgur.com/gp9AfzO.jpeg",
        },
        {
          vmid: "og:url",
          property: "og:url",
          content: `https://artgrab.co/forgotpassword`,
        },
        {
          vmid: "og:title",
          property: "og:title",
          content: `Art Grab : Forgot Password`,
        },
        {
          vmid: "og:description",
          property: "og:description",
          content: `Forgot your password? No problem, just submit your email address here and we'll reset it for you.`,
        },
        {
          vmid: "og:image",
          property: "og:image",
          content: "https://i.imgur.com/gp9AfzO.jpeg",
        },
        {
          vmid: "description",
          property: "description",
          content: `Forgot your password? No problem, just submit your email address here and we'll reset it for you.`,
        },
      ],
    };
  },
  data() {
    return {
      form: {
        email: "",
      },
      loading: false,
    };
  },
  methods: {
    handleSubmit: function () {
      this.loading = true;

      this.axios
        .post(`${apiBaseURL}/api/artv1.1/user/forgotpassword`, {
          email: this.form.email,
        })
        .then((result) => {
          this.loading = false;
          this.showSuccessAlert();
        })
        .catch((error) => {
          /*eslint no-console: ["error", { allow: ["warn", "error"] }] */
          console.error(error);
          this.showErrorAlert(
            "Error sending forgot password email. Please try again in 10 minutes."
          );
        });
    },
    showSuccessAlert() {
      swal.fire({
        type: "success",
        title: "Success!",
        text: "A link to change your password has been sent to the email address provided.",
        confirmButtonColor: "#000",
        onClose: this.goToLogin,
      });
    },
    showErrorAlert(message) {
      swal.fire({
        type: "error",
        title: "Oh no!",
        text: message,
        confirmButtonColor: "#000",
      });
    },
    goToLogin() {
      this.clearForm();
      this.$router.push({ path: "/login" });
    },
    clearForm() {
      this.form.email = "";
      this.loading = false;
    },
  },
  mounted() {
    this.$store.commit("setLayout", "simple-layout");
    this.clearForm();
  },
};
</script>
